import {
  Config,
  ConfigValues,
  Hostname,
  Org,
  Realm,
  SearchIndexEnum,
} from "../../types";
import { constants } from "./definitions";
import { determineRealm } from "./utils";

export const getOscConfig = (): ConfigValues => {
  const realm = determineRealm(window.location.hostname) || Realm.prod;

  const baseConfig = {
    chatWidgetSourceFile: "one-support-center-widget.js",
    incidentStatusPage: {
      [Org.twilio]: "https://status.twilio.com",
      [Org.sendGrid]: "https://status.sendgrid.com",
      [Org.segment]: "https://status.segment.com",
      [Org.zipwhip]: "https://app-status.zipwhip.com",
    },
    searchIndex: SearchIndexEnum.twilio,
    realm,
  };

  const config: Config = {
    [Realm.prod]: {
      ...baseConfig,
      chatWidgetSource: `https://assets.twilio.com/public_assets/support/${constants.chatWidgetVersion}/${baseConfig.chatWidgetSourceFile}`,
      csrfEndpoint: "https://www.twilio.com/api/csrf",
      hostName: "https://help.twilio.com",
      currentAccountCookieDomain: ".www.twilio.com",
      priorityLevelFieldId: "20551717",
      segmentWriteKey: "kAjvDMcGCgzvdvyUuc6EBC8Geclvum1x",
      splitAuthorizationKey: "eo858j4suqc1d9l34ieet2e71bh1cjde52ng",
      supportApiEndpoint: "https://www.twilio.com/console/osc/api",
      wiseOwlAPIEndpoint: "https://www.twilio.com/wise-owl/api",
      supportAuthorizerEndpoint:
        "https://6yftbi9f04.execute-api.us-east-1.amazonaws.com/support-authorizer/v1",
      recaptchaSiteKey: "6Ld0t6glAAAAAIiwPaRRFL0VeM4IKprsXeb8GrLj",
      consoleEndpoint: "https://www.twilio.com/console",
      webEndpoint: Hostname.prod,
      ticketEscalationDelayMinutes: 30,
    },
    [Realm.stage]: {
      ...baseConfig,
      chatWidgetSource: `https://assets.twilio.com/public_assets/support/${constants.chatWidgetVersion}/${baseConfig.chatWidgetSourceFile}`,
      csrfEndpoint: "https://www.stage.twilio.com/api/csrf",
      hostName: "https://help.stage.twilio.com",
      currentAccountCookieDomain: ".www.stage.twilio.com",
      priorityLevelFieldId: "28245318",
      segmentWriteKey: "1rooaFSZEzDxdB9kpJegqDGfRoqD1B8Q",
      splitAuthorizationKey: "1s2p8gdot9t60t768ktoi616e4cocb6ebmj5",
      supportApiEndpoint: "https://www.stage.twilio.com/console/osc/api",
      wiseOwlAPIEndpoint: "https://www.stage.twilio.com/wise-owl/api",
      supportAuthorizerEndpoint:
        "https://44r1dcr1ma.execute-api.us-east-1.amazonaws.com/support-authorizer/v1",
      recaptchaSiteKey: "6Ldxt6glAAAAAOygpaQ3md2sWNMekNSliGFTvNnS",
      consoleEndpoint: "https://www.stage.twilio.com/console",
      webEndpoint: Hostname.stage,
      ticketEscalationDelayMinutes: 30,
    },
    [Realm.dev]: {
      ...baseConfig,
      chatWidgetSource: `https://assets.twilio.com/public_assets/support/${constants.chatWidgetVersion}/${baseConfig.chatWidgetSourceFile}`,
      csrfEndpoint: "https://www.dev.twilio.com/api/csrf",
      hostName: "https://help.dev.twilio.com",
      currentAccountCookieDomain: ".www.dev.twilio.com",
      priorityLevelFieldId: "28245318",
      segmentWriteKey: "8XclIx4jSPDyeVxTdeLqnnk78hTusRIP",
      splitAuthorizationKey: "1s2p8gdot9t60t768ktoi616e4cocb6ebmj5",
      supportApiEndpoint: "https://www.dev.twilio.com/console/osc/api",
      wiseOwlAPIEndpoint: "https://www.dev.twilio.com/wise-owl/api",
      supportAuthorizerEndpoint:
        "https://44r1dcr1ma.execute-api.us-east-1.amazonaws.com/support-authorizer/v1",
      recaptchaSiteKey: "6Ldvt6glAAAAAA-fUuXNdaERxxUUrwhyTNgUxwQP",
      consoleEndpoint: "https://www.dev.twilio.com/console",
      webEndpoint: Hostname.dev,
      ticketEscalationDelayMinutes: 30,
    },
    [Realm.local]: {
      ...baseConfig,
      // Use dev source unless testing locally against support-ui
      // chatWidgetSource: `http://localhost:17981/${baseConfig.chatWidgetSourceFile}`,
      chatWidgetSource: `https://assets.twilio.com/public_assets/support/${constants.chatWidgetVersion}/${baseConfig.chatWidgetSourceFile}`,
      csrfEndpoint: "http://www.local.twilio.com/api/csrf",
      hostName: "http://help.local.twilio.com",
      currentAccountCookieDomain: ".www.local.twilio.com",
      priorityLevelFieldId: "28245318",
      segmentWriteKey: "8XclIx4jSPDyeVxTdeLqnnk78hTusRIP",
      splitAuthorizationKey: "1s2p8gdot9t60t768ktoi616e4cocb6ebmj5",
      recaptchaSiteKey: "6Ldvt6glAAAAAA-fUuXNdaERxxUUrwhyTNgUxwQP",
      supportApiEndpoint: "http://www.local.twilio.com/console/osc/api",
      wiseOwlAPIEndpoint: "http://www.local.twilio.com/wise-owl/api",
      supportAuthorizerEndpoint: "http://localhost:7990/v1",
      consoleEndpoint: "http://www.local.twilio.com/console",
      webEndpoint: Hostname.local,
      ticketEscalationDelayMinutes: 30,
    },
  };

  return config[realm] || config[Realm.local];
};
